import { useEffect, useState } from 'react';

const navItems = [
  { label: '实时爆料', href: '#feed' },
  { label: '今日热度榜', href: '#hot' },
  { label: '栏目专区', href: '#columns' },
  { label: '真香现场', href: '#real' },
  { label: '常见问题', href: '#faq' },
  { label: '瓜友口碑', href: '#voice' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/90 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#home" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-lg text-white">
            🍉
          </span>
          <span
            className={`font-display text-xl tracking-wide ${
              scrolled ? 'text-foreground-950' : 'text-white'
            }`}
          >
            吃瓜cb
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                scrolled
                  ? 'text-foreground-700 hover:bg-primary-100 hover:text-primary-700'
                  : 'text-white/90 hover:bg-white/15 hover:text-white'
              }`}
            >
              {item.label}
            </a>
          ))}
          <a
            href="#submit"
            className="ml-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-bold text-white transition-colors hover:bg-primary-600"
          >
            投一瓜稿
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="展开菜单"
          className={`flex h-10 w-10 items-center justify-center rounded-md text-2xl md:hidden ${
            scrolled ? 'text-foreground-950' : 'text-white'
          }`}
        >
          <i className={open ? 'ri-close-line' : 'ri-menu-line'}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-primary-100 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#submit"
              onClick={() => setOpen(false)}
              className="mt-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-center text-sm font-bold text-white hover:bg-primary-600"
            >
              投一瓜稿
            </a>
          </div>
        </div>
      )}
    </header>
  );
}